export default function warning(
  condition: boolean,
  message: string,
  ...extra: any
) {
  if (process.env.NODE_ENV !== "production" && console) {
    if (condition) {
      // eslint-disable-next-line no-console
      return console.error(
        `[pay-sdk]: ${message}`,
        extra ? { detail: extra } : undefined
      );
    }
  }
}
